import React from "react";

import {display, flex, mb, ml, mv} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";

import {IPoiSet} from "../../offer/detail/actions/fetch_offer_detail_poi";
import {IPoi} from "../types/IPoi";

interface IProps {
    icon: React.ReactNode;
    label?: string;
    poi: IPoi | IPoiSet;
    showName?: boolean;
}

export const PoiItemWithLabel = (props: IProps) => {
    return (
        <div css={[flex("normal", "flex-start"), mb()]}>
            {props.icon}

            <div css={[ml(), mv(0)]}>
                <Text css={display("inline-block")} variant="body_copy_1">
                    {props.label} {props.showName && props.poi.name} - <strong>{Math.round(props.poi.distance)} m</strong>
                </Text>
            </div>
        </div>
    );
};
import React from "react";

import {display, flex, mb, ml, mv} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";

import {IPoiSet} from "../../offer/detail/actions/fetch_offer_detail_poi";
import {IPoi} from "../types/IPoi";

interface IProps {
    icon: React.ReactNode;
    label?: string;
    poi: IPoi | IPoiSet;
    showName?: boolean;
}

export const PoiItemWithLabel = (props: IProps) => {
    return (
        <div css={[flex("normal", "flex-start"), mb()]}>
            {props.icon}

            <div css={[ml(), mv(0)]}>
                <Text css={display("inline-block")} variant="body_copy_1">
                    {props.label} {props.showName && props.poi.name} - <strong>{Math.round(props.poi.distance)} m</strong>
                </Text>
            </div>
        </div>
    );
};
